/**
 * @desc 发货信息
 */
const URL = "/rantion-oms-flow";
import http, { updateResponse } from "@/http";
export function request(
  params: API.omsFlow.systemOrderPackageDeliveryInformation.getDeliveryInformation.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/systemOrderPackageDeliveryInformation/list`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
